import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import { useOrderDraft } from '../Components/Orders/OrderDraftContext';

const ProductCardList = ({ products, maxHeight = '75vh' }) => {
    const navigate = useNavigate();
    const { draft, setProduct, setProducts, removeSelectedProduct } = useOrderDraft();
    const { cartItems, selectedProducts } = draft;

    const handleCardClick = (product) => {
        // setProduct(product);

        // console.log("selectedProducts.includes(product.sku)", selectedProducts.includes(product.sku))
        // console.log("selectedProducts", selectedProducts)
        // console.log("product.sku", product.sku)


        if (selectedProducts.some(selected => selected.sku === product.sku)) {
            removeSelectedProduct(product.sku);
        } else {
            setProducts(product);
        }

        // Navigate with step 1 by default, passing sku and StyleFactory
        navigate(`/SelectVariation`);
    }

    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', padding: 2 }}>
            {/* Scrollable Container */}
            <Box
                sx={{
                    width: '100%',
                    maxHeight: maxHeight,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    paddingRight: 1,
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,0.2)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    },
                }}
            >
                <Grid container spacing={3} sx={{ pb: 2 }}>
                    {products?.map((product) => {
                        // const hasQty = cartItems.some(item => item.sku === product.sku && item.unitQuantity > 0);
                        // const isSelected = selectedProducts.includes(product);
                        const isSelected = selectedProducts.some(selected => selected.sku === product.sku)

                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={product._id}>
                                <Card
                                    onClick={() => handleCardClick(product)}
                                    sx={{
                                        height: '100%',
                                        borderRadius: 2,
                                        // border: hasQty ? '2px solid #b93636' : '1px solid rgba(0, 0, 0, 0.08)',
                                        // backgroundColor: hasQty ? 'rgba(25, 118, 210, 0.02)' : 'background.paper',
                                        border: isSelected ? '2px solid #b93636' : '1px solid rgba(0, 0, 0, 0.08)',
                                        backgroundColor: isSelected ? 'rgba(25, 118, 210, 0.02)' : 'background.paper',
                                        // transition: 'all 0.25s ease-in-out',
                                        '&:hover': {
                                            boxShadow: isSelected ? '0 8px 24px rgba(25, 118, 210, 0.2)' : 8,
                                            // transform: 'translateY(-6px)',
                                            borderColor: isSelected ? '#b93636' : 'primary.light'
                                        },
                                    }}
                                >
                                    <CardActionArea sx={{ height: '100%', '&[data-active]': { backgroundColor: 'action.selected', } }}>
                                        <CardContent sx={{ height: '100%', p: 2.5 }}>
                                            <Grid container spacing={2} alignItems="center">
                                                {/* Image */}
                                                <Grid item xs={12} sm={4}>
                                                    <CardMedia
                                                        component="img"
                                                        image={product.Picture || 'https://via.placeholder.com/300x300?text=No+Image'}
                                                        alt={product.Brand || 'Product'}
                                                        sx={{
                                                            height: 160,
                                                            objectFit: 'contain',
                                                            borderRadius: 1,
                                                            backgroundColor: '#f8f9fa',
                                                        }}
                                                        onError={(e) => {
                                                            e.target.onerror = null; // Prevent infinite loop
                                                            e.target.src = "/blank-image.png";
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Details */}
                                                <Grid item xs={12} sm={5}>
                                                    <Typography
                                                        variant="subtitle1"
                                                        fontWeight="700"
                                                        gutterBottom
                                                        sx={{ color: 'text.primary' }}
                                                    >
                                                        {product.StyleFactory}
                                                    </Typography>

                                                    <Typography variant="body2" color="text.secondary" gutterBottom sx={{ fontWeight: 500 }}>
                                                        {product.sku}
                                                    </Typography>

                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                                        {product.Material1}
                                                    </Typography>
                                                </Grid>

                                                {/* Pricing */}
                                                <Grid item xs={12} sm={3}>
                                                    <Typography
                                                        variant="caption"
                                                        fontWeight="bold"
                                                        sx={{ lineHeight: 1.8, display: 'block', color: 'text.primary' }}
                                                    >
                                                        {product.Size1 && (
                                                            <>
                                                                {product.Size1}:{' '}
                                                                {product.Price1 ? (
                                                                    <span style={{ color: '#1976d2', fontWeight: 700 }}>
                                                                        ${product.Price1}
                                                                    </span>
                                                                ) : ''}
                                                                <br />
                                                            </>
                                                        )}

                                                        {product.Size2 && (
                                                            <>
                                                                {product.Size2}:{' '}
                                                                {product.Price2 ? (
                                                                    <span style={{ color: '#1976d2', fontWeight: 700 }}>
                                                                        ${product.Price2}
                                                                    </span>
                                                                ) : ''}
                                                                <br />
                                                            </>
                                                        )}

                                                        {product.Size3 && (
                                                            <>
                                                                {product.Size3}:{' '}
                                                                {product.Price3 ? (
                                                                    <span style={{ color: '#1976d2', fontWeight: 700 }}>
                                                                        ${product.Price3}
                                                                    </span>
                                                                ) : ''}
                                                            </>
                                                        )}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </Box>
    );
};

export default ProductCardList;
